import * as React from 'react';
import { SelectChangeEvent, Select, MenuItem } from '@mui/material';
import moment from 'moment';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
export function MonthPicker(props: any) {
  const { Month, setMonth, Year } = props;
  const handleChangeMonth = (event: SelectChangeEvent) => {
    setMonth(event.target.value as string);
  };
  const now = dayjs();
  const currentMonthFormatted = now.format('MMMM');
  const currentMonthIndex = now.get('months');
  const allMonths = moment.months();
  const [ListOfMonth, setListOfMonth] = useState<string[]>(allMonths);

  useEffect(() => {
    if (Year && Year.toString() === now.year().toString()) {
      if (allMonths.findIndex((month) => month === Month) < currentMonthIndex) {
        setMonth(currentMonthFormatted);
      }
      setListOfMonth(allMonths.slice(now.month()));
    } else {
      setListOfMonth(allMonths);
    }
  }, [Year]);

  return (
    <Select
      IconComponent={KeyboardArrowDownIcon}
      labelId="select-month"
      id="select-month"
      value={Month}
      defaultValue={now.format('MMMM')}
      onChange={handleChangeMonth}
      inputProps={{
        id: 'select-month-input',
      }}
    >
      {ListOfMonth.map((month, index) => (
        <MenuItem key={index} value={index + 1} id={'month-' + index}>
          {month}
        </MenuItem>
      ))}
    </Select>
  );
}
